import styled from 'styled-components';

export const FlexRow = styled.div<{
    gap: number;
    flexDirection: string;
}>`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection ?? 'row'};
    gap: ${({ gap }) => gap ?? 0}px;
`;
